export default __webpack_public_path__ + "static/media/icon-aro-disbursement.10299e8e.svg";